/* itamo-options.js v2 - SC内製化 メラミンボード */
(function(){
var TV={
'12mm':{id:42898260230383,price:0},
'15mm':{id:42898127126767,price:700},
'18mm':{id:42898127159535,price:1600},
'21mm':{id:43779293479151,price:2300},
'24mm':{id:43779297771759,price:3100}
};
var BP={'なし':0,'メラミン貼り(同柄)':8000,'メラミン貼り(別柄)':8000};
function fmtPrice(y){return '\u00a5'+y.toLocaleString('ja-JP');}
function updatePrice(total){
document.querySelectorAll('.price-item--regular').forEach(function(el){el.textContent=fmtPrice(total);});
}
function initMelamine(){
var el=document.querySelector('.itamo-options');
if(!el)return;
var pid=el.dataset.productId;
var pd=(window.itamoProductData||{})[pid];
if(!pd)return;
var backSel=document.getElementById('itamo-back-select');
var thkSel=document.getElementById('itamo-thickness-select');
var swatchGrp=document.getElementById('itamo-back-swatches-group');
var radios=document.querySelectorAll('.itamo-swatch-radio');
var priceEl=document.getElementById('itamo-option-price');
var priceVal=document.getElementById('itamo-option-price-value');
var colorEl=document.getElementById('itamo-selected-back-color');
var state={back:'',backColor:'',thickness:'18mm',basePrice:pd.basePrice||17600};
function toggleSwatches(show){
if(!swatchGrp)return;
swatchGrp.style.display=show?'':'none';
radios.forEach(function(r){r.required=show;if(!show)r.checked=false;});
if(!show){state.backColor='';if(colorEl)colorEl.textContent='';}
}
function recalc(){
var bAdd=BP[state.back]||0;
var tAdd=(TV[state.thickness]||{price:0}).price;
var tot=bAdd+tAdd;
var grand=state.basePrice+tot;
if(priceEl&&priceVal){
if(tot>0){priceEl.style.display='';priceVal.textContent=fmtPrice(tot);}
else{priceEl.style.display='none';}
}
updatePrice(grand);
}
if(backSel)backSel.addEventListener('change',function(){
state.back=this.value;
toggleSwatches(this.value==='\u30e1\u30e9\u30df\u30f3\u8cbc\u308a(\u5225\u67c4)');
recalc();
});
if(thkSel)thkSel.addEventListener('change',function(){state.thickness=this.value;recalc();});
radios.forEach(function(r){
r.addEventListener('change',function(){
if(this.checked){
state.backColor=this.value;
if(colorEl)colorEl.textContent='\u9078\u629e\u4e2d\uff1a'+this.value;
document.querySelectorAll('.itamo-swatch').forEach(function(s){s.classList.remove('is-selected');});
this.closest('.itamo-swatch').classList.add('is-selected');
}
});
});
state.thickness=thkSel?thkSel.value:'18mm';
state.back=backSel?backSel.value:'';
recalc();
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initMelamine);}
else{initMelamine();}
})();